// src/components/ProductCard.jsx
import React from "react";
import { Link } from "react-router-dom";
import imageMap from "../assets/data/imageMap";
import fallbackImage from "../assets/images/fallback.jpg"; // Optional fallback

const ProductCard = ({ product }) => {
  const imageSrc = imageMap[product.Image] || fallbackImage;

  return (
    <Link to={`/products/${product.ID}`} className="block">
      <div className="bg-white border rounded-xl shadow-sm p-4 hover:shadow-lg transition cursor-pointer h-full">
        {/* Product Image */}
        <div className="bg-gray-100 h-40 mb-4 rounded-lg flex items-center justify-center overflow-hidden">
          <img
            src={imageSrc}
            alt={product.Item}
            className="object-contain h-full max-w-full"
            loading="lazy" 
          />
        </div>

        {/* Product Name */}
        <h3 className="text-lg font-bold mb-1 text-gray-800">
  {product.DisplayName || product.Item}
</h3>

        {/* Type and Series */}
      {product.Category !== "Accessories" && (
  <p className="text-sm text-gray-600">
    Model: <span className="font-medium">{product.Type}</span> | Series:{" "}
    <span className="font-medium">{product.Series}</span>
  </p>
)}
      </div>
    </Link>
  );
};

export default ProductCard;
